import React from "react";
import GroupLesson from "../../../asset/images/home/lesson-group.png";
import { Link } from 'react-router-dom';
const Explanation = () => {
    return (
        <div className="app-container">
            <div className="main-content-wrapper flex-1 flex flex-col overflow-hidden w-full">
        {/* Main Content */}
                <main className="main-content bg-white flex-1 p-4 lg:p-8">
                    <div className="p-4 lg:p-3">
                        <div> <div className="lg:col-span-2">
                            <div className="bg-white rounded-xl shadow-md p-3">
                                <h3 className="text-2xl font-bold mb-6 text-gray-700">
                            Lesson 1: What is the Science of Reading? </h3>

        {/* Colored boxes */}
        <img
            src={GroupLesson}
            alt="Lesson Image"
            className="w-full h-auto mb-6 rounded-lg shadow-sm"
        />

        {/* Introduction Text */}
        <h4 className="font-bold text-gray-800 mb-2 text-3xl">Introduction</h4>
        {/* Introduction Block with Subtle Left Line */}
        <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed">
            <p className="mb-3">
                The science of reading is a research-backed approach to teaching reading that focuses on explicit and systematic instruction of key literacy skills. It emphasizes the importance of foundational skills like phonemic awareness, phonics, fluency, vocabulary, and comprehension. The science of reading provides evidence for which techniques are most effective in helping all students become proficient readers.
            </p>

            <p className="font-medium mb-2">
                What are the components that make up the Science of Reading?
            </p>

            <ul className="list-disc pl-5 space-y-1">
                <li>Phonemic Awareness: identifying the most basic single letter sounds.</li>
                <li>Phonics: the blending of letter sounds to create and pronounce words.</li>
                <li>Fluency: the ability to read accurately, quickly, and with expression, allowing readers to focus on comprehension.</li>
                <li>Vocabulary: knowledge of the meanings of words, both in isolation and in context.</li>
                <li>Comprehension: the ability to understand and make meaning from written text.</li>
            </ul>
        </div>

        {/* Buttons */}
        <div className="flex justify-end mt-6">
            <Link to={'/dashboard/modules'}>
                <button className="px-6 py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-8">
                    ← Back to Modules
                </button>
            </Link>
            <Link to={'/dashboard/modules/quiz-question'}>
                <button className="px-6 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                    Continue Lesson →
                </button>
            </Link>
        </div>
    </div>
    </div>
    </div>
    </div>
    </main>
    </div>
    </div>

);
};

export default Explanation;
